import request from '../request.js'

export const contents = data=>{
	return request({
		url:`contents?pageNo=${data.pageNo}&pageSize=${data.pageSize}`,
		method:"get"
	})
}

export const contentById = id=>{
	return request({
		url:"contentById?id=" + id,
		method:"get"
	})
}

export const contentByClassify = data=>{
	return request({
		url:`queryByClass?class_id=${data.class_id}&pageNo=${data.pageNo}&pageSize=${data.pageSize}`,
		method:'get'
	})
}

export const delContent = id=>{
	return request({
		url:"deleteContent?id=" + id,
		method:'get'
	})
}

export const addContent = data=>{
	return request({
		url:"addContent",
		method:"post",
		data
	})
}

export const updateContent = data=>{
	return request({
		url:"updateContent",
		method:'post',
		data
	})
}

export const uploadImg = data=>{
	return request({
		url:"upload",
		method:'post',
		data
	})
}

export const uploadImgByUrlApi = data=>{
	return request({
		url:"uploadImgByUrl",
		method:'post',
		data
	})
}